var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("main-title", {
        attrs: { arrowClick: false },
        scopedSlots: _vm._u([
          {
            key: "rightBtn",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "imggs",
                  attrs: { src: require("images/video/icon-fh.png") },
                  on: {
                    click: function ($event) {
                      return _vm.fhClick()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("videos", { attrs: { index: _vm.index } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }